import { renderPage } from "renderPage"
import { ClubForumTagPage } from "./Page"

renderPage({ component: ClubForumTagPage })
